import { observer } from "mobx-react-lite";
import { Fragment, useEffect } from "react";
import {
  Button,
  ConfigProvider,
  Empty,
  Form,
  Modal,
  Select,
  Space,
  Input,
  FormProps,
  Card,
  InputNumber,
  Col,
  Row,
  message,
  Cascader,
  Upload,
  UploadProps,
} from "antd";
import { MyApplicationStore } from "../../../../store";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";

function ApplyNumber(props: any) {
  const form = Form.useFormInstance();
  const { TextArea } = Input;
  const submitPower = (value: any) => {
    value.applicationDetails = value.items;
    if (
      (!value.items || value.items.length == 0) &&
      !MyApplicationStore.applyFormData
    ) {
      message.warning("至少提交一个申请");
      return;
    }
    MyApplicationStore.submitApplyNumberPreviw({ ...value });
  };

  const handleChange = (value: any, option: any) => {
    MyApplicationStore.xpoolNo = value;
  };

  const getFormData = (
    changeValue: powerSearchData,
    allValues: powerSearchData
  ) => {
    MyApplicationStore.setApplySearchForm({ ...allValues });
  };

  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };
  const addProps: UploadProps = {
    beforeUpload(info) {
      if (
        info.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        info.type === "application/vnd.ms-excel"
      ) {
        return false;
      } else {
        message.error("请上传xlsx格式");
        return Upload.LIST_IGNORE;
      }
    },
    onChange: (info) => {
      //删除文件时不提示上传成功
      if (
        info.file &&
        (info.file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          info.file.type === "application/vnd.ms-excel") &&
        info.fileList.length > 0
      ) {
        MyApplicationStore.applyFormData = info;
        message.success("上传成功");
      } else {
        //删除文件，清空
        MyApplicationStore.applyFormData = null;
      }
    },
  };

  const onFinishFailed: FormProps<any>["onFinishFailed"] = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const toControlApply = () => {
    MyApplicationStore.controlApply();
  };

  return (
    <Fragment>
      <Modal
        width="60%"
        centered
        title={"新增X池号码"}
        open={MyApplicationStore.applyNumberModal}
        destroyOnClose={true}
        onCancel={() => toControlApply()}
        footer={null}
      >
        <Form
          form={form}
          autoComplete="off"
          labelCol={{ span: 8 }}
          onValuesChange={getFormData}
          onFinishFailed={onFinishFailed}
          onFinish={submitPower}
        >
          <div
            style={{
              overflow: "auto",
              maxHeight: "calc(100vh - 200px)",
              margin: "20px 0",
            }}
          >
            <ConfigProvider renderEmpty={tableEmptyRender}>
              <Row>
                <Col span={12}>
                  <Form.Item
                    label="号池名称"
                    name="xpoolNo"
                    rules={[{ required: true, message: "请选择号池" }]}
                  >
                    <Select
                      placeholder="请选择号池"
                      onChange={handleChange}
                      showSearch
                      allowClear={true}
                      optionFilterProp="label"
                      options={MyApplicationStore.getAllXPoolWriteInfo.map(
                        (item: any) => ({
                          value: item.no,
                          label: item.name,
                        })
                      )}
                    ></Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="虚拟运营商"
                    name="vnoId"
                    rules={[{ required: true, message: "请选择虚拟运营商" }]}
                  >
                    <Select
                      allowClear={true}
                      showSearch
                      optionFilterProp="label"
                      placeholder="请选择虚拟运营商"
                      options={MyApplicationStore.virtualCarrier.map(
                        (item: any) => ({
                          value: item.openId,
                          label: item.displayName,
                        })
                      )}
                    ></Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="预计周投诉个数" name="complaintLimit">
                    <InputNumber style={{ width: "100%" }} min={0} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="预计投比(1/W分钟)" name="expectedRatio">
                    <InputNumber style={{ width: "100%" }} min={0} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="speechScene" label="话术场景">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="speechRange"
                    label="话术范围"
                    labelCol={{ span: 4 }}
                  >
                    <TextArea allowClear />
                  </Form.Item>
                </Col>
              </Row>
              <Col span={12}>
                <Form.Item
                  label="请上传附件："
                  name="upload"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e && e.fileList;
                  }}
                >
                  <Upload name="text" {...addProps} maxCount={1}>
                    <Button icon={<UploadOutlined />}>上传号码文件</Button>
                  </Upload>
                </Form.Item>
              </Col>
            </ConfigProvider>
            <Form.List name="items">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    display: "flex",
                    rowGap: 16,
                    flexDirection: "column",
                  }}
                >
                  {fields.map((field) => (
                    <Card
                      size="small"
                      title={`申请 ${field.name + 1}`}
                      key={field.key}
                      extra={
                        <CloseOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                      }
                    >
                      <Row>
                        <Col span={12}>
                          <Form.Item
                            label="省市"
                            name={[field.name, "provinceCityCode"]}
                            rules={[
                              { required: true, message: "请选择所属市" },
                            ]}
                          >
                            <Cascader
                              options={MyApplicationStore.provinceCityCode}
                              fieldNames={{ children: "cities" }}
                              placeholder="请选择省市"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="数量"
                            name={[field.name, "quantity"]}
                            rules={[{ required: true, message: "请输入数量" }]}
                          >
                            <InputNumber style={{ width: "100%" }} min={0} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    style={{ marginBottom: "10px" }}
                  >
                    新增一条申请
                  </Button>
                </div>
              )}
            </Form.List>
          </div>
          <Form.Item
            style={{ textAlign: "right" }}
            wrapperCol={{ span: 18, offset: 6 }}
          >
            <Space>
              <Button
                htmlType="reset"
                onClick={() => MyApplicationStore.controlApply()}
              >
                取消
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={MyApplicationStore.buttonLoading}
              >
                确定
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
}

export default observer(ApplyNumber);
